import { FormEvent, useEffect, useState } from "react";
import LoadingModal from "../../../../components/loadingModal";
import { Button, Col, Form, Row } from "react-bootstrap";
import styles from "../emissao/nfse.module.css";
import Select from "react-select";
import $ from "jquery";
import "jquery-mask-plugin";
import { defineValueInInput } from "../../../../components/funcForInput";
import { formatarDinheiro, formatarPorcentagem, getInputDinheiro, getInputPorcentagem, handleCalcTributo, handleCalcTributos, handleCalcValorLiquido, handleChangeInTributo, handleChangeInValor } from "../emissao/ViewNotaPage";
import { toast } from "react-toastify";
import removeAllErrorMsg from "../../../../components/funcRemoveAllErros";
import { getUrlSearchParams } from "../../../urlParams";
import { ApiEndpoints, reqGetNew, reqPatch, reqPost, reqPostNew, reqPut } from "../../../../config/apiClient";
import stylesModelo from "../../styles/modelo.module.css";
import funcSleep from "../../../../components/funcSleep";
import { NFSE_NBS_CLASS_TRIB_OPTIONS, NFSE_NBS_CST_OPTIONS, NFSE_NBS_OPERACAO_COD_OPTIONS, NFSE_NBS_OPTIONS } from "../emissao/ServicoNBSOptions";

export default function NFSeModeloCadastrarPage() {
    useEffect(() => {
        $(".dinheiro").mask("###.###.###.###.###.###.##0,00", { reverse: true, placeholder: "0,00" });
        $(".porcentagem").mask("000.00", { reverse: true, placeholder: "0.00" });
        definirCamposSelect();
        // eslint-disable-next-line
    }, []);

    // Dados formulário
    const [idModelo, setIdModelo] = useState<number | null>(null);
    const [filtros, setFiltros] = useState<any>({ clientes: [], clientes_tipos: [], servicos: [], servicos_antigos: [], servicos_empresas: [], cidades: [], empresas: [], servicos_mun: [] });
    const [empresasFiltro, setEmpresasFiltro] = useState<any[]>([]);
    const [clientesFiltro, setClientesFiltro] = useState<any[]>([]);
    const [clientesDadosFiltro, setClientesDadosFiltro] = useState<any[]>([]);
    const [cidadesFiltro, setCidadesFiltro] = useState<any[]>([]);
    const [servicosFiltro, setServicosFiltro] = useState<any[]>([]);
    const [servicosDadosFiltro, setServicosDadosFiltro] = useState<any[]>([]);
    const [idServicoFiltroMun, setIdServicoFiltroMun] = useState<any[]>([]);
    const [idServicoNBS, setIdServicoNBS] = useState<any>({ value: "0", label: "Não Selecionado" });
    const [idIBSCBSOperacaoCod, setIdIBSCBSOperacaoCod] = useState<any>({ value: "0", label: "Não Selecionado" });
    const [idIBSCBSCstCod, setIdIBSCBSCstCod] = useState<any>({ value: "0", label: "Não Selecionado" });
    const [idIBSCBSClassTribCod, setIdIBSCBSClassTribCod] = useState<any>({ value: "0", label: "Não Selecionado" });

    const choiceNaoSelecionado = { value: "0", label: "Não Selecionado" };
    const [idEmpresa, setIdEmpresa] = useState<any>(choiceNaoSelecionado);
    const [empresa, setEmpresa] = useState<any>({});
    const [idCliente, setIdCliente] = useState<any>(choiceNaoSelecionado);
    const [codServico, setCodServico] = useState<any>(choiceNaoSelecionado);
    const [codCidade, setCodCidade] = useState<any>(choiceNaoSelecionado);
    const [idServicoMun, setIdServicoMun] = useState<any>(choiceNaoSelecionado);
    const [showServicoMun, setShowServicoMun] = useState<boolean>(false);
    const [showServicoNBS, setShowServicoNBS] = useState<boolean>(false);

    const [loading, setLoading] = useState<boolean>(false);

    async function carregarModelo(filtros: any) {
        const urlDados = getUrlSearchParams();
        const id_modelo = urlDados.get("id");
        if (id_modelo === null) {
            document.title = "Modelo Cadastrar | OB PORTUS";
            return;
        }
        document.title = "Modelo Editar | OB PORTUS";
        setIdModelo(Number(id_modelo));
        const api = await reqPost(ApiEndpoints.nfseModeloConsultar, { id_modelo: id_modelo });
        if (api.status === 200) {
            const modelo = api.data;
            console.log(modelo);

            const choiceEmpresa = {
                value: `${modelo.id_empresa.id_empresa}`,
                label: `${modelo.id_empresa.nome} ${modelo.id_empresa.cnpj}`,
            };
            setIdEmpresa(choiceEmpresa);
            handleChangeEmpresa(choiceEmpresa, filtros);

            const cidadesAux: any[] = filtros.cidades.filter((reg: any) => reg.cod_cidade === modelo.servico_cidade_cod);
            const cidade = cidadesAux[0];
            const choiceCidade = {
                value: `${modelo.servico_cidade_cod}`,
                label: `${modelo.servico_cidade_descricao}/${cidade.uf}`,
            };
            setCodCidade(choiceCidade);
            // handleChangeCidade(choiceCidade)

            const servico_mun = modelo.servico_mun_id;
            if (servico_mun !== null) {
                setShowServicoMun(true);
                handleServiceMun(modelo.servico_cidade_cod, filtros);
                setIdServicoMun({
                    value: `${servico_mun.id}`,
                    label: `#${servico_mun.servico_cod}-${servico_mun.servico_cod_mun} ${servico_mun.servico_descricao}`,
                });
            }

            if (modelo.servico_nbs_cod !== null) {
                const options_nbs = NFSE_NBS_OPTIONS.filter((reg) => reg.value === modelo.servico_nbs_cod);
                if (options_nbs.length > 0) {
                    setShowServicoNBS(true);
                    const nbs_cod = options_nbs[0];
                    setIdServicoNBS({
                        value: `${nbs_cod.value}`,
                        label: `${nbs_cod.label}`,
                    });
                }

                const options_operacao_cod = NFSE_NBS_OPERACAO_COD_OPTIONS.filter((reg) => reg.value === modelo.IBSCBS_operacao_cod);
                if (options_operacao_cod.length > 0) {
                    const operacao_cod = options_operacao_cod[0];
                    setIdIBSCBSOperacaoCod({
                        value: `${operacao_cod.value}`,
                        label: `${operacao_cod.label}`,
                    });
                }

                const options_cst = NFSE_NBS_CST_OPTIONS.filter((reg) => reg.value === modelo.IBSCBS_cst_cod);
                if (options_cst.length > 0) {
                    const cst_cod = options_cst[0];
                    setIdIBSCBSCstCod({
                        value: `${cst_cod.value}`,
                        label: `${cst_cod.label}`,
                    });
                }

                const options_class_trib = NFSE_NBS_CLASS_TRIB_OPTIONS.filter((reg) => reg.value === modelo.IBSCBS_class_trib_cod);
                if (options_class_trib.length > 0) {
                    const class_trib_cod = options_class_trib[0];
                    setIdIBSCBSClassTribCod({
                        value: `${class_trib_cod.value}`,
                        label: `${class_trib_cod.label}`,
                    });
                }
            }

            const choiceCliente = {
                value: `${modelo.id_cliente.id_cliente}`,
                label: `#${modelo.id_cliente.id_cliente} ${modelo.id_cliente.nome} ${modelo.id_cliente.tipo === "PJ" ? `CNPJ ${modelo.id_cliente.cnpj}` : `CPF ${modelo.id_cliente.cpf}`}`,
            };
            setIdCliente(choiceCliente);
            // handleChangeCliente(choiceCliente)

            const servicosAux: any[] = filtros.servicos.filter((reg: any) => reg.servico_cod === modelo.servico_cod);
            const servico = servicosAux[0];
            const choiceServico = {
                value: `${modelo.servico_cod}`,
                label: `#${modelo.servico_cod} ${modelo.servico_descricao} - ${servico.tributos_situacao === 1 ? "Retido" : "Tributado"}`,
                // "label": `#${modelo.servico_cod} ${modelo.servico_descricao}`
            };
            setCodServico(choiceServico);
            // handleChangeServico(choiceServico)
            const situacao_tributos_cod = modelo.trib_iss_ret;
            defineValueInInput("situacao_tributos", situacao_tributos_cod);

            defineValueInInput("nome", modelo.nome);
            defineValueInInput("situacao_modelo", modelo.situacao);
            defineValueInInput("nfse_emitir", modelo.nfse_emitir);
            defineValueInInput("valor", formatarDinheiro(modelo.valor_servicos));
            defineValueInInput("servico_dia_data_servico", modelo.servico_dia_data_servico);
            defineValueInInput("tipo_referencia", modelo.tipo_referencia === null ? "0" : String(modelo.tipo_referencia));
            defineValueInInput("servico_descricao", modelo.servico_descriminacao);
            defineValueInInput("servico_info_complementar", modelo.servico_info_complementar);

            let form: any = document.getElementById("formNFSeModelo");

            form.tipo.value = modelo.tipo;

            form.situacao_pis_cofins.value = modelo.trib_fed_ret_PISCOFINS === null ? 0 : modelo.trib_fed_ret_PISCOFINS;

            form.IRRF.value = formatarPorcentagem(modelo.IRRF);
            form.IRRF_V.value = formatarDinheiro(modelo.IRRF_V);

            form.INSS.value = formatarPorcentagem(modelo.CP);
            form.INSS_V.value = formatarDinheiro(modelo.CP_V);

            form.COFINS.value = formatarPorcentagem(modelo.COFINS);
            form.COFINS_V.value = formatarDinheiro(modelo.COFINS_V);

            form.CSLL.value = formatarPorcentagem(modelo.CSLL);
            form.CSLL_V.value = formatarDinheiro(modelo.CSLL_V);
            form.CSLL_V2.value = formatarDinheiro(modelo.CSLL_V2);

            form.PIS.value = formatarPorcentagem(modelo.PIS);
            form.PIS_V.value = formatarDinheiro(modelo.PIS_V);

            form.ISS.value = formatarPorcentagem(modelo.ISS);
            form.ISS_V.value = formatarDinheiro(modelo.ISS_V);

            // Atualizado: 15/06/2026
            // if (modelo.id_empresa.nfs_situacao_simp_nac === 3) {
            //     form.ISS.value = formatarPorcentagem(modelo.id_empresa.nfs_ISS)
            // } else {
            //     form.ISS.value = formatarPorcentagem(modelo.ISS)
            //     form.ISS_V.value = formatarDinheiro(modelo.ISS_V)
            // }

            handleCalcTributos();
            defineValueInInput("BASE_V", formatarDinheiro(modelo.valor_servicos));
        }
    }

    async function definirCamposSelect() {
        const filtros = await getFiltros();
        let cidadesAux = filtros.cidades.map((item: any, index: any) => ({
            value: `${item.cod_cidade}`,
            label: `${item.nome}/${item.uf}`,
        }));
        setCidadesFiltro(cidadesAux);
        let empresasAux = filtros.empresas.map((item: any, index: any) => ({
            value: `${item.id_empresa}`,
            label: `${item.nome} ${item.cnpj}`,
        }));
        setEmpresasFiltro(empresasAux);

        await carregarModelo(filtros);
    }
    async function getFiltros(): Promise<any> {
        const apiFiltros = await reqGetNew(ApiEndpoints.nfseFiltros);
        if (apiFiltros.status === 200) {
            const filtrosAux = {
                clientes: apiFiltros.data.clientes,
                clientes_tipos: apiFiltros.data.clientes_tipos,
                servicos: apiFiltros.data.servicos,
                servicos_antigos: apiFiltros.data.servicos_antigos,
                servicos_empresas: apiFiltros.data.servicos_empresas,
                cidades: apiFiltros.data.cidades,
                empresas: apiFiltros.data.empresas,
                servicos_mun: apiFiltros.data.servicos_mun,
            };
            setFiltros(filtrosAux);
            return filtrosAux;
        }
        return filtros;
    }
    function handleChangeEmpresa(choice: any, filtros: any) {
        const id_empresa = Number(choice.value);
        const empresasAux = filtros.empresas.filter((reg: any) => reg.id_empresa === id_empresa);
        if (empresasAux.length === 0) {
            return;
        }

        const empresa = empresasAux[0];
        setEmpresa(empresa);

        const clientesFiltro: any[] = filtros.clientes.filter((reg: any) => reg.id_empresa === empresa.id_empresa && reg.situacao === 1);
        setClientesDadosFiltro(clientesFiltro);
        let clientesAux = clientesFiltro.map((item: any, index: any) => ({
            value: `${item.id_cliente}`,
            label: `#${item.id_cliente} ${item.nome} ${item.tipo === "PJ" ? `CNPJ ${item.cnpj}` : `CPF ${item.cpf}`}`,
        }));
        setClientesFiltro(clientesAux);
        setIdCliente(choiceNaoSelecionado);

        let servicosEmpresasFiltro: any[] = filtros.servicos_empresas.filter((reg: any) => reg.id_empresa === empresa.id_empresa);
        let servicosFiltro: any[] = [];
        for (let servico of servicosEmpresasFiltro) {
            const item = Number(String(servico.cod_serv).split(".")[0]);
            const subitem = Number(String(servico.cod_serv).split(".")[1]);
            const servicos = filtros.servicos.filter((reg: any) => reg.servico_item === item && reg.servico_subitem === subitem);
            if (servicos.length > 0) {
                servicosFiltro.push(servicos[0]);
            }
            continue;
        }
        setServicosDadosFiltro(servicosFiltro);
        let servicosAux = servicosFiltro.map((item: any, index: any) => ({
            value: `${item.servico_cod}`,
            label: `#${item.servico_cod} ${item.servico_descricao} - ${item.tributos_situacao === 1 ? "Retido" : "Tributado"}`,
        }));
        setServicosFiltro(servicosAux);
        setCodServico(choiceNaoSelecionado);

        if (empresa.nfs_situacao_simp_nac === 3) {
            defineValueInInput("ISS", formatarPorcentagem(empresa.nfs_ISS));
            handleCalcTributo("ISS");
            handleCalcValorLiquido();
        }
    }
    function handleChangeCliente(choice: any) {
        const clienteAux: any[] = clientesDadosFiltro.filter((reg: any) => reg.id_cliente === Number(choice.value));
        if (clienteAux.length === 0) {
            return;
        }
        const cliente = clienteAux[0];

        if (cliente.id_tipo_cliente === 2) {
            defineValueInInput("situacao_pis_cofins", "2");
        }
        if (empresa.nfs_situacao_simp_nac === 1) {
            let tipo_cliente = filtros.clientes_tipos.filter((reg: any) => reg.id_tipo_cliente === cliente.id_tipo_cliente)[0];
            defineValueInInput("IRRF", formatarPorcentagem(tipo_cliente.IRRF));
            handleCalcTributo("IRRF");
            defineValueInInput("INSS", formatarPorcentagem(tipo_cliente.INSS));
            handleCalcTributo("INSS");
            defineValueInInput("COFINS", formatarPorcentagem(tipo_cliente.COFINS));
            handleCalcTributo("COFINS");
            defineValueInInput("CSLL", formatarPorcentagem(tipo_cliente.CSLL));
            handleCalcTributo("CSLL");
            defineValueInInput("PIS", formatarPorcentagem(tipo_cliente.PIS));
            handleCalcTributo("PIS");
            toast.info(`Tipo de Cliente selecionado: ${tipo_cliente.nome}!`, {
                containerId: 1,
                position: "top-center",
                theme: "dark",
                autoClose: 2000,
            });
            let cidade = filtros.cidades.filter((reg: any) => reg.cod_cidade === cliente.cod_cidade);
            if (cidade.length > 0) {
                cidade = cidade[0];
                setCodCidade({
                    value: `${cidade.cod_cidade}`,
                    label: `${cidade.nome}/${cidade.uf}`,
                });
                defineValueInInput("ISS", formatarPorcentagem(cidade.iss));
                handleCalcTributo("ISS");
            }
        }
        if (empresa.nfs_situacao_simp_nac === 3) {
            let cidade = filtros.cidades.filter((reg: any) => reg.cod_cidade === cliente.cod_cidade);
            if (cidade.length > 0) {
                cidade = cidade[0];
                setCodCidade({
                    value: `${cidade.cod_cidade}`,
                    label: `${cidade.nome}/${cidade.uf}`,
                });
            }
        }
        handleCalcValorLiquido();
    }
    function handleChangeServico(choice: any) {
        const servicosAux: any[] = servicosDadosFiltro.filter((reg: any) => reg.servico_cod === choice.value);
        if (servicosAux.length === 0) {
            return;
        }
        const servico = servicosAux[0];

        const situacao_tributos_cod = servico.tributos_situacao === 1 ? 2 : 1;
        defineValueInInput("situacao_tributos", situacao_tributos_cod);
        const clientes: any[] = clientesFiltro.filter((reg: any) => reg.id_cliente === Number(idCliente.value));
        if (clientes.length > 0) {
            const cliente = clientes[0];
            if (cliente.id_tipo_cliente === 2) {
                defineValueInInput("situacao_pis_cofins", "0");
            } else {
                defineValueInInput("situacao_pis_cofins", servico.tributos_situacao === 1 ? "3" : "0");
            }
        } else {
            defineValueInInput("situacao_pis_cofins", servico.tributos_situacao === 1 ? "3" : "0");
        }
        handleCalcTributos();
    }
    function handleChangeCidade(choice: any) {
        const cidadesAux: any[] = filtros.cidades.filter((reg: any) => reg.cod_cidade === Number(choice.value));
        if (cidadesAux.length === 0) {
            return;
        }
        const cidade = cidadesAux[0];
        if (Object.values(empresa).length === 0) {
            return;
        }

        if (empresa.nfs_situacao_simp_nac === 1) {
            defineValueInInput("ISS", formatarPorcentagem(cidade.iss));
            handleCalcTributo("ISS");
            handleCalcValorLiquido();
        }
    }
    function handleServiceMun(cidade_cod: number, filtros: any) {
        console.log(`cidade_cod=${cidade_cod}`);
        cidade_cod = Number(cidade_cod);
        const servicos_mun: any[] = filtros.servicos_mun.filter((reg: any) => reg.cidade_cod === cidade_cod);
        setIdServicoMun({ value: "0", label: "Não Selecionado" });
        if (servicos_mun.length > 0) {
            setShowServicoMun(true);
            let servicosAux = servicos_mun.map((item: any, index: any) => ({
                value: `${item.id}`,
                label: `#${item.servico_cod}-${item.servico_cod_mun} ${item.servico_descricao}`,
            }));
            setIdServicoFiltroMun(servicosAux);
        } else {
            setShowServicoMun(false);
        }
    }

    function handleSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault();
        event.stopPropagation();
        removeAllErrorMsg();

        const form: any = event.target;
        let formValidado = true;

        let urlParams: URLSearchParams = getUrlSearchParams();
        let id_modelo: number | null = null;
        if (Number(urlParams.get("id")) > 0) {
            id_modelo = Number(urlParams.get("id"));
        }

        const dados: NFSeModeloCadastroDto = {
            id_modelo: id_modelo,
            nome: form.nome.value,
            situacao: Number(form.situacao_modelo.value),
            nfse_emitir: Number(form.nfse_emitir.value),
            tipo: Number(form.tipo.value),
            tipo_referencia: Number(form.tipo_referencia.value),
            id_empresa: Number(idEmpresa.value),
            id_cliente: Number(idCliente.value),
            servico_cod: codServico.value,
            servico_descricao: "",
            servico_cod_mun: null,
            servico_descricao_mun: null,
            servico_mun_id: idServicoMun.value === "0" ? null : Number(idServicoMun.value),
            servico_cidade_cod: Number(codCidade.value),
            servico_cidade_descricao: "",
            servico_descriminacao: form.servico_descricao.value,
            servico_info_complementar: form.servico_info_complementar.value,
            servico_dia_data_servico: form.servico_dia_data_servico.value,
            servico_nbs_cod: idServicoNBS.value,
            valor_servicos: getInputDinheiro("valor"),
            valor_liquido: getInputDinheiro("LIQUIDO_V"),
            valor_tributos: getInputDinheiro("TRIBUTOS_V"),
            trib_iss: 1,
            trib_iss_ret: Number(form.situacao_tributos.value),
            ISS: getInputPorcentagem("ISS"),
            ISS_V: getInputDinheiro("ISS_V"),
            trib_fed_ret_PISCOFINS: Number(form.situacao_pis_cofins.value),
            PIS: getInputPorcentagem("PIS"),
            PIS_V: getInputDinheiro("PIS_V"),
            COFINS: getInputPorcentagem("COFINS"),
            COFINS_V: getInputDinheiro("COFINS_V"),
            CP: getInputPorcentagem("INSS"),
            CP_V: getInputDinheiro("INSS_V"),
            IRRF: getInputPorcentagem("IRRF"),
            IRRF_V: getInputDinheiro("IRRF_V"),
            CSLL: getInputPorcentagem("CSLL"),
            CSLL_V: getInputDinheiro("CSLL_V"),
            CSLL_V2: getInputDinheiro("CSLL_V2"),
            IBSCBS_operacao_cod: idIBSCBSOperacaoCod.value,
            IBSCBS_cst_cod: idIBSCBSCstCod.value,
            IBSCBS_class_trib_cod: idIBSCBSClassTribCod.value,
        };

        if (dados.nome === "") {
            form.nome.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (dados.tipo !== 1 && dados.tipo !== 2) {
            form.tipo_aux.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (dados.id_empresa <= 0) {
            form.id_empresa_aux.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (dados.id_cliente <= 0) {
            form.id_cliente_aux.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        const servicos = servicosDadosFiltro.filter((reg) => reg.servico_cod === dados.servico_cod);
        if (servicos.length === 0) {
            form.cod_servico_aux.nextElementSibling.style.display = "block";
            formValidado = false;
        } else {
            const servico = servicos[0];
            dados.servico_descricao = servico.servico_descricao;
        }

        if (showServicoNBS) {
            if (dados.servico_nbs_cod === "0") {
                form.servico_nbs_cod_aux.nextElementSibling.style.display = "block";
                formValidado = false;
            }
            if (dados.IBSCBS_operacao_cod === "0") {
                form.IBSCBS_operacao_cod_aux.nextElementSibling.style.display = "block";
                formValidado = false;
            }
            if (dados.IBSCBS_cst_cod === "0") {
                form.IBSCBS_cst_cod_aux.nextElementSibling.style.display = "block";
                formValidado = false;
            }
            if (dados.IBSCBS_class_trib_cod === "0") {
                form.IBSCBS_class_trib_cod_aux.nextElementSibling.style.display = "block";
                formValidado = false;
            }
        } else {
            dados.servico_nbs_cod = null;
            dados.IBSCBS_operacao_cod = null;
            dados.IBSCBS_cst_cod = null;
            dados.IBSCBS_class_trib_cod = null;
        }

        const cidades = filtros.cidades.filter((reg: any) => reg.cod_cidade === dados.servico_cidade_cod);
        if (cidades.length === 0) {
            form.cod_cidade_aux.nextElementSibling.style.display = "block";
            formValidado = false;
        } else {
            const cidade = cidades[0];
            dados.servico_cidade_descricao = cidade.nome;
        }
        if (dados.servico_mun_id !== null) {
            const servicos_mun = filtros.servicos_mun.filter((reg: any) => reg.id === dados.servico_mun_id);
            if (servicos_mun.length > 0) {
                const servico_mun = servicos_mun[0];
                dados.servico_cod_mun = servico_mun.servico_cod_mun;
                dados.servico_descricao_mun = servico_mun.servico_descricao;
            }
        }
        if (dados.servico_dia_data_servico === "" || dados.servico_dia_data_servico.length > 2) {
            form.servico_dia_data_servico.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (dados.valor_servicos === "" || Number(dados.valor_servicos) <= 0) {
            form.valor.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (dados.trib_iss_ret === 0) {
            form.situacao_tributos.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (dados.trib_fed_ret_PISCOFINS === 99) {
            if (dados.PIS !== "0.00" || dados.COFINS !== "0.00") {
                toast.error("CSLL/PIS/COFINS não pode haver valores!", {
                    containerId: 1,
                    position: "top-center",
                    theme: "dark",
                });
                formValidado = false;
            }
        } else {
            if (dados.trib_fed_ret_PISCOFINS >= 0 && dados.trib_fed_ret_PISCOFINS !== 1 && dados.trib_fed_ret_PISCOFINS !== 2) {
                if (dados.PIS === "0.00" || dados.COFINS === "0.00" || dados.CSLL === "0.00") {
                    toast.error("Necessário informar CSLL/PIS/COFINS!", {
                        containerId: 1,
                        position: "top-center",
                        theme: "dark",
                    });
                    formValidado = false;
                }
            }
            if (dados.trib_fed_ret_PISCOFINS === 1 || dados.trib_fed_ret_PISCOFINS === 2) {
                if (dados.CSLL !== "0.00") {
                    toast.error("CSLL não pode haver valores!", {
                        containerId: 1,
                        position: "top-center",
                        theme: "dark",
                    });
                    formValidado = false;
                }
                if (dados.PIS === "0.00" || dados.COFINS === "0.00") {
                    toast.error("Necessário informar PIS/COFINS!", {
                        containerId: 1,
                        position: "top-center",
                        theme: "dark",
                    });
                    formValidado = false;
                }
            }
        }
        if (dados.servico_descriminacao === "" || dados.servico_descriminacao.length < 15) {
            form.servico_descricao.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (dados.tipo_referencia !== 0) {
            let referencia_definida = String(dados.servico_descriminacao).search("#ref#");
            if (referencia_definida < 0) {
                form.tipo_referencia.nextElementSibling.style.display = "block";
                formValidado = false;
            }
        }

        console.log(dados);

        if (!formValidado) {
            return;
        }

        if (dados.id_modelo === null) {
            cadastrar(dados);
            return;
        }
        if (dados.id_modelo !== null) {
            editar(dados);
            return;
        }
    }
    async function cadastrar(dados: NFSeModeloCadastroDto) {
        setLoading(true);
        const api = await reqPut(ApiEndpoints.nfseModeloCadastrar, dados);
        if (api.status === 201) {
            console.log(api.data);
            toast.success("Modelo cadastrado com sucesso!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            await funcSleep(500);
            window.location.assign(`/nfse/modelos`);
        }
        setLoading(false);
    }
    async function editar(dados: NFSeModeloCadastroDto) {
        setLoading(true);
        const api = await reqPatch(ApiEndpoints.nfseModeloEditar, dados);
        if (api.status === 200) {
            console.log(api.data);
            toast.success("Modelo editado com sucesso!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            await funcSleep(500);
            window.location.assign(`/nfse/modelos`);
        }
        setLoading(false);
    }
    async function deletar() {
        if (!window.confirm("Tem certeza que deseja excluir o modelo?")) {
            return;
        }
        setLoading(true);
        const dados = {
            id_modelo: idModelo,
        };
        const api = await reqPostNew(ApiEndpoints.nfseModeloDeletar, dados);
        if (api.status === 200) {
            console.log(api.data);
            toast.success("Modelo deletado!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            await funcSleep(500);
            window.location.assign(`/nfse/modelos`);
        }
        setLoading(false);
    }

    return (
        <div id="main">
            <div className="div-row-space-between">
                <h1 id="titleMain">NFS-e {idModelo === null ? "Cadastrar Modelo" : "Editar Modelo"}</h1>
                <Button
                    onClick={() => {
                        window.location.assign(`/nfse/modelos`);
                    }}
                >
                    Voltar
                </Button>
            </div>
            <br></br>

            <LoadingModal
                show={loading}
                handleClose={(event: any) => {
                    setLoading(!loading);
                }}
            />
            <Form id="formNFSeModelo" onSubmit={handleSubmit} noValidate>
                <Row className="mb-15-forms">
                    <Col className="col-6">
                        <Form.Group>
                            <Form.Label>Nome do Modelo:</Form.Label>
                            <Form.Control name="nome" type="text" id="nome" />
                            <Form.Control.Feedback type="invalid">Informe o nome do modelo!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Situação:</Form.Label>
                            <Form.Select name="situacao_modelo" id="situacao_modelo" aria-label="Selecione o status:">
                                <option value="1">Ativo</option>
                                <option value="0">Inativo</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Emitir NFS-e (apenas Mensal):</Form.Label>
                            <Form.Select name="nfse_emitir" id="nfse_emitir" aria-label="Selecione a opção:">
                                <option value="0">Não</option>
                                <option value="1">Sim</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-6">
                        <Form.Group style={{ width: "100%" }}>
                            <Form.Label>Empresa:</Form.Label>
                            <Select
                                name="id_empresa"
                                id="id_empresa"
                                options={empresasFiltro}
                                value={idEmpresa}
                                placeholder="Selecione a Empresa"
                                onChange={(choice: any) => {
                                    setIdEmpresa(choice);
                                    handleChangeEmpresa(choice, filtros);
                                }}
                                styles={customSelectStylesNfs}
                            />
                            <Form.Control name="id_empresa_aux" type="text" id="id_empresa_aux" placeholder="" style={{ display: "none" }} />
                            <Form.Control.Feedback type="invalid">Informe o Cliente!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-6">
                        <Form.Group style={{ fontWeight: "bold" }}>
                            <Form.Label>
                                <b>CRIAR NOTA MENSALMENTE ?</b>
                            </Form.Label>
                            <br></br>
                            <Form.Check inline label="Mensal" value="1" name="tipo" type="radio" style={{ marginTop: "0px" }} id={`inline-radio-1-tipo`} className={stylesModelo.formRadios} />
                            <Form.Check inline label="Não, salvar apenas modelo" value="2" name="tipo" type="radio" id={`inline-radio-2-tipo`} className={stylesModelo.formRadios} />
                            <Form.Control name="tipo_aux" type="text" id="tipo_aux" placeholder="" style={{ display: "none" }} />
                            <Form.Control.Feedback type="invalid">Informe o tipo do modelo!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <br></br>

                <Row className={styles.identificacao_nfse}>
                    <h2 id={styles.identificacao_nfse_title} style={{ marginBottom: "0px" }}>
                        Cliente e Serviço
                    </h2>
                </Row>

                <Row className="mb-15-forms">
                    {" "}
                    {/* Cliente - Data Competência - Serviço */}
                    <Col className="col-4">
                        <Form.Group style={{ width: "100%" }}>
                            <Form.Label>Tomador:</Form.Label>
                            <Select
                                name="id_cliente"
                                id="id_cliente"
                                options={clientesFiltro}
                                value={idCliente}
                                placeholder="Selecione o Cliente"
                                onChange={(choice: any) => {
                                    setIdCliente(choice);
                                    handleChangeCliente(choice);
                                }}
                                styles={customSelectStylesNfs}
                            />
                            <Form.Control name="id_cliente_aux" type="text" id="id_cliente_aux" placeholder="" style={{ display: "none" }} />
                            <Form.Control.Feedback type="invalid">Informe o Cliente!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>Dia Data Serviço:</Form.Label>
                            <Form.Control name="servico_dia_data_servico" type="number" id="servico_dia_data_servico" placeholder="Ex.: 1 ou 31" />
                            <Form.Control.Feedback type="invalid">Informe o dia que deve ser usado na data de serviço!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className={showServicoMun ? "col-4" : "col-6"}>
                        <Form.Group style={{ width: "100%" }}>
                            <Form.Label>Serviço:</Form.Label>
                            <Select
                                name="cod_servico"
                                id="cod_servico"
                                options={servicosFiltro}
                                value={codServico}
                                placeholder="Selecione o Serviço"
                                onChange={(choice: any) => {
                                    setCodServico(choice);
                                    handleChangeServico(choice);
                                }}
                                styles={customSelectStylesNfs}
                            />
                            <Form.Control name="cod_servico_aux" type="text" id="cod_servico_aux" placeholder="" style={{ display: "none" }} />
                            <Form.Control.Feedback type="invalid">Informe o Serviço!</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group id={styles.show_servico_nbs}>
                            <input type="checkbox" id="servico_nbs" name="servico_nbs" defaultChecked={showServicoNBS} checked={showServicoNBS} onChange={() => setShowServicoNBS(!showServicoNBS)} />
                            <Form.Label htmlFor="servico_nbs">Declarar informações NBS?</Form.Label>
                        </Form.Group>
                    </Col>
                    {showServicoMun && (
                        <Col className="col-2">
                            <Form.Group style={{ width: "100%" }}>
                                <Form.Label>Serviço Municipal:</Form.Label>
                                <Select
                                    name="id_servico_mun"
                                    id="id_servico_mun"
                                    options={idServicoFiltroMun}
                                    value={idServicoMun}
                                    placeholder="Selecione o Serviço"
                                    onChange={(choice: any) => {
                                        setIdServicoMun(choice);
                                    }}
                                    styles={customSelectStylesNfs}
                                />
                            </Form.Group>
                        </Col>
                    )}
                </Row>

                <div style={{ display: showServicoNBS ? "block" : "none" }}>
                    <Row className={styles.identificacao_nfse}>
                        <h2 id={styles.identificacao_nfse_title} style={{ marginBottom: "0px" }}>
                            Informações NBS
                        </h2>
                    </Row>

                    <Row className="mb-15-forms">
                        <Col className="col-3">
                            <Form.Group style={{ width: "100%" }}>
                                <Form.Label>Item da NBS correspondente ao serviço prestado:</Form.Label>
                                <Select
                                    name="servico_nbs_cod"
                                    id="servico_nbs_cod"
                                    options={NFSE_NBS_OPTIONS}
                                    value={idServicoNBS}
                                    placeholder="Selecione o Serviço NBS"
                                    onChange={(choice: any) => {
                                        setIdServicoNBS(choice);
                                    }}
                                    styles={customSelectStylesNfs}
                                />
                                <Form.Control name="servico_nbs_cod_aux" type="text" id="servico_nbs_cod_aux" placeholder="" style={{ display: "none" }} />
                                <Form.Control.Feedback type="invalid">Informe o item da NBS!</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col className="col-3">
                            <Form.Group style={{ width: "100%" }}>
                                <Form.Label>Código indicador da operação:</Form.Label>
                                <Select
                                    name="IBSCBS_operacao_cod"
                                    id="IBSCBS_operacao_cod"
                                    options={NFSE_NBS_OPERACAO_COD_OPTIONS}
                                    value={idIBSCBSOperacaoCod}
                                    placeholder="Selecione o Serviço NBS"
                                    onChange={(choice: any) => {
                                        setIdIBSCBSOperacaoCod(choice);
                                    }}
                                    styles={customSelectStylesNfs}
                                />
                                <Form.Control name="IBSCBS_operacao_cod_aux" type="text" id="IBSCBS_operacao_cod_aux" placeholder="" style={{ display: "none" }} />
                                <Form.Control.Feedback type="invalid">Informe o código indicador da operação!</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col className="col-3">
                            <Form.Group style={{ width: "100%" }}>
                                <Form.Label>Código de Situação Tributária:</Form.Label>
                                <Select
                                    name="IBSCBS_cst_cod"
                                    id="IBSCBS_cst_cod"
                                    options={NFSE_NBS_CST_OPTIONS}
                                    value={idIBSCBSCstCod}
                                    placeholder="Selecione o Serviço NBS"
                                    onChange={(choice: any) => {
                                        setIdIBSCBSCstCod(choice);
                                    }}
                                    styles={customSelectStylesNfs}
                                />
                                <Form.Control name="IBSCBS_cst_cod_aux" type="text" id="IBSCBS_cst_cod_aux" placeholder="" style={{ display: "none" }} />
                                <Form.Control.Feedback type="invalid">Informe o Código de Situação Tributária!</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col className="col-3">
                            <Form.Group style={{ width: "100%" }}>
                                <Form.Label>Código de Classificação Tributária:</Form.Label>
                                <Select
                                    name="IBSCBS_class_trib_cod"
                                    id="IBSCBS_class_trib_cod"
                                    options={NFSE_NBS_CLASS_TRIB_OPTIONS}
                                    value={idIBSCBSClassTribCod}
                                    placeholder="Selecione o Serviço NBS"
                                    onChange={(choice: any) => {
                                        setIdIBSCBSClassTribCod(choice);
                                    }}
                                    styles={customSelectStylesNfs}
                                />
                                <Form.Control name="IBSCBS_class_trib_cod_aux" type="text" id="IBSCBS_class_trib_cod_aux" placeholder="" style={{ display: "none" }} />
                                <Form.Control.Feedback type="invalid">Informe o Classificação Tributária!</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                </div>

                <Row className={styles.identificacao_nfse}>
                    <h2 id={styles.identificacao_nfse_title} style={{ marginBottom: "0px" }}>
                        Valores
                    </h2>
                </Row>

                <Row className="mb-15-forms">
                    {" "}
                    {/* Valor - Situação de Tributos (RETIDO OU NAO) - Cidade - ISS */}
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>Valor:</Form.Label>
                            <Form.Control name="valor" type="text" id="valor" className="dinheiro" autoComplete="off" placeholder="0,00" style={{ fontWeight: "bold" }} onKeyUp={handleChangeInValor} />
                            <Form.Control.Feedback type="invalid">Informe o valor da NF!</Form.Control.Feedback>
                            <Form.Control name="dinheiro_aux" type="text" id="dinheiro_aux" className="dinheiro" placeholder="0,00" style={{ display: "none" }} />
                            <Form.Control name="porcentagem_aux" type="text" id="porcentagem_aux" className="porcentagem" placeholder="0.00" style={{ display: "none" }} />
                        </Form.Group>
                    </Col>
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>Situação Alíquota (ISS):</Form.Label>
                            <Form.Select
                                name="situacao_tributos"
                                id="situacao_tributos"
                                aria-label="Selecione o opção"
                                onChange={(event) => {
                                    handleCalcTributos();
                                }}
                            >
                                <option value="0">Selecione</option>
                                <option value="1">Tributado - ISS</option>
                                <option value="2">Retido - ISS</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">Informe a Situação dos tributos!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    {/*<Col className='col-2'>
                        <Form.Group>
                            <Form.Label>Situação Tributos:</Form.Label>
                            <Form.Control name='situacao' type="text" id='situacao' readOnly disabled />
                            <Form.Control.Feedback type="invalid">
                                Informe a situação da NF!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>*/}
                    <Col className="col-4">
                        <Form.Group style={{ width: "100%" }}>
                            <Form.Label>Cidade Serviço:</Form.Label>
                            <Select
                                name="cod_cidade"
                                id="cod_cidade"
                                options={cidadesFiltro}
                                value={codCidade}
                                placeholder="Selecione a Cidade"
                                onChange={(choice: any) => {
                                    setCodCidade(choice);
                                    handleChangeCidade(choice);
                                    handleServiceMun(choice.value, filtros);
                                }}
                                styles={customSelectStylesNfs}
                            />
                            <Form.Control name="cod_cidade_aux" type="text" id="cod_cidade_aux" placeholder="" style={{ display: "none" }} />
                            <Form.Control.Feedback type="invalid">Informe a Cidade!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-2">
                        <p className={styles.titleValorTributo} id="ISS_descricao">
                            ISS {Object.values(empresa).length > 0 ? empresa.nfs_situacao_simp_nac === 3 && ` - SIMPLES NACIONAL` : ""}
                        </p>
                        <div className={styles.divInputsTributo}>
                            <p>Aliquota (%)</p>
                            <input name="ISS" type="text" id="ISS" className="porcentagem" autoComplete="off" placeholder="0.00" onKeyUp={handleChangeInTributo} />
                        </div>
                        <div className={styles.divInputsTributo}>
                            <p>Valor (R$)</p>
                            <input name="ISS_V" type="text" id="ISS_V" placeholder="0,00" readOnly disabled />
                        </div>
                    </Col>
                    <Col className="col-2">
                        {/* <Form.Group>
                            <Form.Label>Situação Tributos Federais:</Form.Label>
                            <Form.Select name="situacao_pis_cofins" id="situacao_pis_cofins" aria-label="Selecione o opção" onChange={() => { handleCalcTributos() }}>
                                <option value="0">Não informar</option>
                                <option value="1">Retido</option>
                                <option value="2">Tributado</option>
                                <option value="3">PIS Retido / COFINS Tributado</option>
                                <option value="4">PIS Tributado / COFINS Retido</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Informe a Situação do PIS/COFINS!
                            </Form.Control.Feedback>
                        </Form.Group> */}
                        <Form.Group>
                            <Form.Label>Situação Tributos Federais:</Form.Label>
                            <Form.Select
                                name="situacao_pis_cofins"
                                id="situacao_pis_cofins"
                                aria-label="Selecione o opção"
                                onChange={() => {
                                    handleCalcTributos();
                                }}
                            >
                                <option value="99">Não informar</option>
                                <option value="0">PIS/COFINS/CSLL Tributados</option>
                                <option value="1">PIS/COFINS Retido</option>
                                <option value="2">PIS/COFINS Tributado</option>
                                <option value="3">PIS/COFINS/CSLL Retidos</option>
                                <option value="4">PIS/COFINS Retidos, CSLL Tributado</option>
                                <option value="5">PIS Retido, COFINS/CSLL Tributado</option>
                                <option value="6">COFINS Retido, PIS/CSLL Tributado</option>
                                <option value="7">PIS Tributado, COFINS/CSLL Retidos</option>
                                <option value="8">PIS/COFINS Tributados, CSLL Retido</option>
                                <option value="9">COFINS Tributado, PIS/CSLL Retidos</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">Informe a Situação do PIS/COFINS!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    {" "}
                    {/* Tributos: IRRF - INSS - COFINS - CSLL - PIS - LIQUIDO */}
                    <Col className="col-2">
                        <p className={styles.titleValorTributo} id="IRRF_descricao">
                            IRRF
                        </p>
                        <div className={styles.divInputsTributo}>
                            <p>Aliquota (%)</p>
                            <input name="IRRF" type="text" id="IRRF" className="porcentagem" autoComplete="off" placeholder="0.00" onKeyUp={handleChangeInTributo} />
                        </div>
                        <div className={styles.divInputsTributo}>
                            <p>Valor (R$)</p>
                            <input name="IRRF_V" type="text" id="IRRF_V" placeholder="0,00" readOnly disabled />
                        </div>
                    </Col>
                    <Col className="col-2">
                        <p className={styles.titleValorTributo} id="INSS_descricao">
                            INSS (CP)
                        </p>
                        <div className={styles.divInputsTributo}>
                            <p>Aliquota (%)</p>
                            <input name="INSS" type="text" id="INSS" className="porcentagem" autoComplete="off" placeholder="0.00" onKeyUp={handleChangeInTributo} />
                        </div>
                        <div className={styles.divInputsTributo}>
                            <p>Valor (R$)</p>
                            <input name="INSS_V" type="text" id="INSS_V" placeholder="0,00" readOnly disabled />
                        </div>
                    </Col>
                    <Col className="col-2">
                        <p className={styles.titleValorTributo} id="CSLL_descricao">
                            CSLL
                        </p>
                        <div className={styles.divInputsTributo}>
                            <p>Aliquota (%)</p>
                            <input name="CSLL" type="text" id="CSLL" className="porcentagem" autoComplete="off" placeholder="0.00" onKeyUp={handleChangeInTributo} />
                        </div>
                        <div className={styles.divInputsTributo}>
                            <p>Valor (R$)</p>
                            <input name="CSLL_V" type="text" id="CSLL_V" placeholder="0,00" readOnly disabled />
                            <input name="CSLL_V2" type="text" id="CSLL_V2" placeholder="0,00" readOnly disabled style={{ display: "none" }} />
                        </div>
                    </Col>
                    <Col className="col-2">
                        <p className={styles.titleValorTributo} id="PIS_descricao">
                            PIS
                        </p>
                        <div className={styles.divInputsTributo}>
                            <p>Aliquota (%)</p>
                            <input name="PIS" type="text" id="PIS" className="porcentagem" autoComplete="off" placeholder="0.00" onKeyUp={handleChangeInTributo} />
                        </div>
                        <div className={styles.divInputsTributo}>
                            <p>Valor (R$)</p>
                            <input name="PIS_V" type="text" id="PIS_V" placeholder="0,00" readOnly disabled />
                        </div>
                    </Col>
                    <Col className="col-2">
                        <p className={styles.titleValorTributo} id="COFINS_descricao">
                            COFINS
                        </p>
                        <div className={styles.divInputsTributo}>
                            <p>Aliquota (%)</p>
                            <input name="COFINS" type="text" id="COFINS" className="porcentagem" autoComplete="off" placeholder="0.00" onKeyUp={handleChangeInTributo} />
                        </div>
                        <div className={styles.divInputsTributo}>
                            <p>Valor (R$)</p>
                            <input name="COFINS_V" type="text" id="COFINS_V" placeholder="0,00" readOnly disabled />
                        </div>
                    </Col>
                    <Col className="col-2">
                        <p className={styles.titleValorTributoResumo}>RESUMO</p>
                        <div className={styles.divInputsTributo}>
                            <p>Base (R$)</p>
                            <input name="BASE_V" type="text" id="BASE_V" placeholder="0,00" className="dinheiro" style={{ fontWeight: "bold" }} readOnly disabled />
                        </div>
                        <div className={styles.divInputsTributo}>
                            <p>Tributos (R$)</p>
                            <input name="TRIBUTOS_V" type="text" id="TRIBUTOS_V" placeholder="0,00" className="dinheiro" style={{ fontWeight: "bold" }} readOnly disabled />
                        </div>
                        <div className={styles.divInputsTributo}>
                            <p>Líquido (R$)</p>
                            <input name="LIQUIDO_V" type="text" id="LIQUIDO_V" placeholder="0,00" className="dinheiro" style={{ fontWeight: "bold" }} readOnly disabled />
                        </div>
                    </Col>
                </Row>
                <Row className="mb-15-forms" style={{ marginTop: "-40px" }}>
                    <Col className="col-10 div-row" style={{ textAlign: "center" }}>
                        <p style={{ width: "100%" }}>
                            Tributos IRRF/INSS: R${" "}
                            <span id="total_tributos_federais_outros" style={{ marginRight: "25px" }}>
                                0,00
                            </span>
                            Contribuições Sociais: R${" "}
                            <span id="total_contribuicoes_sociais" style={{ marginRight: "25px" }}>
                                0,00
                            </span>
                            TOTAL TRIBUTOS FEDERAIS: R${" "}
                            <span id="total_tributos_federais" style={{ marginRight: "25px" }}>
                                0,00
                            </span>
                        </p>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    {" "}
                    {/* Descrição do Serviço NFSe */}
                    <Col className="col-5">
                        <Form.Group className="mt-0 mb-3">
                            <Form.Label>Descrição do Serviço:</Form.Label>
                            <Form.Control as="textarea" rows={8} maxLength={1000} name="servico_descricao" id="servico_descricao" autoComplete="off" />
                            <Form.Control.Feedback type="invalid">Preencha a descrição do serviço!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-4">
                        <Form.Group className="mt-0 mb-3">
                            <Form.Label>Informações Complementares:</Form.Label>
                            <Form.Control as="textarea" rows={8} maxLength={2000} name="servico_info_complementar" id="servico_info_complementar" autoComplete="off" />
                            <Form.Control.Feedback type="invalid">Preencha as informações complementares!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Mês de referência (MM/YYYY):</Form.Label>
                            <Form.Select name="tipo_referencia" id="tipo_referencia" aria-label="Selecione o mês de referência">
                                <option value="1">Mês anterior competência</option>
                                <option value="2">Mês igual competência</option>
                                <option value="0">Não informar mês automático</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">Ponto de #ref# não encontrada na descriminacao!</Form.Control.Feedback>
                            <br></br>
                            <Form.Label style={{ color: "grey" }}>Adicione #ref# (Ex.: 10/2024) no texto.</Form.Label>
                            <Form.Label style={{ color: "grey" }}>Opcional #periodo# (Ex.: 01/10/2024 À 31/10/2024) no texto.</Form.Label>
                            <Form.Label style={{ color: "grey" }}>Opcional #obs# no texto, antes da emissão das notas será verificado se todas as OBSs foram editadas.</Form.Label>
                            <Form.Label style={{ color: "grey" }}>Opcional preencher valores: #IRFF#, #INSS#, #COFINS#, #CSLL#, #PIS#, #ISS#, #VALOR#, #LIQUIDO#.</Form.Label>
                        </Form.Group>
                    </Col>
                </Row>

                <Button type="submit" variant="success" style={{ marginRight: "10px" }}>
                    {idModelo === null ? "Cadastrar Modelo" : "Editar Modelo"}
                </Button>
                {idModelo !== null && (
                    <Button
                        variant="danger"
                        onClick={() => {
                            deletar();
                        }}
                    >
                        Deletar
                    </Button>
                )}
            </Form>
        </div>
    );
}

const customSelectStylesNfs = {
    control: (baseStyles: any, state: any) => ({
        ...baseStyles,
        borderColor: "#dee2e6",
        backgroundColor: state.isDisabled ? "#E9ECEF" : "white",
    }),
    singleValue: (provided: any, state: any) => ({
        ...provided,
        color: state.isDisabled ? "black" : "black",
    }),
};

interface NFSeModeloCadastroDto {
    id_modelo: number | null;
    nome: string;
    situacao: number;
    nfse_emitir: number;
    tipo: number;
    tipo_referencia: number;
    id_empresa: number;
    id_cliente: number;
    servico_cod: string;
    servico_descricao: string;
    servico_cod_mun: string | null;
    servico_descricao_mun: string | null;
    servico_mun_id: number | null;
    servico_cidade_cod: number;
    servico_cidade_descricao: string;
    servico_descriminacao: string;
    servico_info_complementar: string;
    servico_dia_data_servico: string;
    servico_nbs_cod: string | null;
    valor_servicos: string;
    valor_liquido: string;
    valor_tributos: string;
    trib_iss: number;
    trib_iss_ret: number;
    ISS: string;
    ISS_V: string;
    trib_fed_ret_PISCOFINS: number;
    PIS: string;
    PIS_V: string;
    COFINS: string;
    COFINS_V: string;
    CP: string;
    CP_V: string;
    IRRF: string;
    IRRF_V: string;
    CSLL: string;
    CSLL_V: string;
    CSLL_V2: string;
    IBSCBS_operacao_cod: string | null;
    IBSCBS_cst_cod: string | null;
    IBSCBS_class_trib_cod: string | null;
}
